<template>
  <div class="pa-4">
    <v-btn @click="$router.back()" class="back-btn">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col lg="12">
      <tabla
        Titulo="Reporte de Vehículo"
        :Cabecera="Cabecera"
        :Items="Items"
        :data="data"
        :per_page="per_page"
        :from="from"
        :to="to"
        :total="total"
        :page="page"
        :ItemTotal="ItemTotal"
        @getVehiculos="getVehiculos"
        :Loading="Loader"
        :Excel="false"
        :Crear="true"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/vehiculos/tabla.vue";

import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "Vehiculos",
  components: {
    tabla,
  },
  watch: {
    Items(newVal) {
      this.data = newVal.data;
      this.per_page = this.Items.per_page;
      this.page = this.Items.current_page;

      // Calcular `from` y `to` para el footer
      this.from = this.Items.from;
      this.to = this.Items.to;
      console.log("Items actualizados:", newVal);
    },
  },
  created() {
    //this.cargarVehiculos({page: 1, per_page: 10, search: ""});
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Opc.",
          value: "acciones",
          width: 100,
          sortable: false,
          align: "left",
        },
        { text: "Id", value: "id", width: 70, align: "left" },
        { text: "Placa", value: "placa", width: 100, align: "left" },
        { text: "Código", value: "codigo", width: 100, align: "left" },
        {
          text: "Tipo",
          value: "tipo",
          width: 100,
          sortable: false,
          align: "left",
        },
        {
          text: "Marca",
          value: "marca",
          width: 100,
          sortable: false,
          align: "left",
        },
        {
          text: "Modelo",
          value: "modelo",
          width: 100,
          sortable: false,
          align: "left",
        },
        {
          text: "Configuración",
          value: "configuracion",
          sortable: false,
          width: 130,
          align: "left",
        },
        {
          text: "Aplicación",
          value: "aplicacion",
          sortable: false,
          width: 120,
          align: "left",
        },
        {
          text: "Registro",
          value: "fecha_registro",
          width: 110,
          align: "left",
        },
        {
          text: "Planta",
          value: "nomplanta",
          sortable: false,
          width: 120,
          align: "left",
        },
        {
          text: "Estado",
          value: "nomestado",
          sortable: false,
          width: 100,
          align: "left",
        },
      ],
      data: [],
      per_page: 10,
      page: 1,
      from: 1,
      to: 10,
      total: 0,
      sortBy: "id",
      sortDirection: "desc",
    };
  },
  methods: {
    ...mapActions("vehiculo", ["cargarVehiculos", "cargarDatosAdicionales"]),
    getVehiculos({
      page = 1,
      per_page = 10,
      search = "",
      sortBy = "id",
      sortDirection = "desc",
    }) {
      this.cargarVehiculos({
        page,
        per_page,
        search,
        sortBy,
        sortDirection,
      }).then(() => {
        this.data = this.Items.data;
        this.per_page = this.Items.per_page;
        this.page = this.Items.current_page;

        // Calcular `from` y `to` para el footer
        this.from = this.Items.from;
        this.to = this.Items.to;
        this.total = this.Items.total;
      });
    },
  },

  computed: {
    ...mapGetters("vehiculo", ["Items", "ItemTotal"]),
    ...mapState("vehiculo", ["Loader"]),
  },
  mounted() {
    this.cargarDatosAdicionales();
    //this.getVehiculos();
  },
};
</script>
